// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2fc16ba6","453":"f4862b6d"}[chunkId] + ".chunk.js";
};